//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DonationForm from "./DonationForm";
import { getContentByCode, getArrForTitle, handleTouchScroling } from '~/utils/utils';

export default {
  components: {
    DonationForm
  },
  data() {
    return {
      chooseMasterpiece: false,
      stepTwo: false
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
  },
  mounted() {
    if(this.$route.hash === '#home-donation-form') {
      setTimeout(() => {
        document.querySelector('#home-donation-form').scrollIntoView({
          behavior: 'smooth'
        });
      }, 1000);
    }
  },
  methods: {
    getTextArr(text) {
      return getArrForTitle(text)
    },
    getText(code) {
      return getContentByCode(this.getTextBlocks.data.data, code)
    }
  },
  // computed: {
  //   eventsListeners() {
  //     return {
  //       ...this.$listeners,
  //       ...handleTouchScroling(this, 'homeDonationForm')
  //     }
  //   },
  // },
  // props:{
  //   chooseMasterpiece: {
  //     type: Boolean,
  //     default: false
  //   }
  // }
  chimera: {
    getTextBlocks () {
      return {
        url: '/api/v1/textBlocks/get/',
        key: 'get-text-blocks-donat',
        auto: true,
        params: {
          code: ['home_donat_title','home_donat_text', 'home_donat_title_step_2'],
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
}
